module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<strong>User id</strong>: ' +
__e( userId ) +
'\n<br><strong>Company id</strong>: ' +
__e( company.id ) +
'\n';
 if (company.id !== settings.id) { ;
__p += '\n    <br><strong>Settings id</strong>: ' +
__e( settings.id ) +
';\n';
 } ;
__p += '\n\n<br><strong>Company</strong>: ' +
__e( company.name ) +
'\n<br><strong>SalesForceId</strong>: ' +
__e( company.salesForceId ) +
'\n<br><strong>Internal</strong>: ' +
__e( company.internal ) +
'\n<br><strong>State</strong>: ' +
__e( company.state ) +
'\n<br><strong>Bundle strategy</strong>: ' +
__e( settings.bundleStrategy && settings.bundleStrategy.name || "Standard" ) +
'\n<br><strong>Font integrations enabled</strong>: ' +
__e( fontIntegrationsEnabled ? "Enabled" : "Disabled" );

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/NavBarCurrentPrincipalViewTooltip.tpl
// module id = 2805
// module chunks = 0